<app-alert-box-component 
  (OnButtonClick)="onAlertButtonClick($event)"
  (OnAlertClose)="closeAlert($event)" 
  (OnAlertVisibility)="alertVisibility($event)"
  [bShowSecondButton]="bShowSecondAlertButton"
  [alertHeaderText]="alertHeaderText" 
  [alertBodyText]="alertBodyText" 
  [closeButtonText]="alertCloseButtonText"
  [secondButtonText]="alertSecondButtonText"
  [data]="alertBoxData"
  [bAlert]="bAlert"></app-alert-box-component>

<c-modal [visible]="bShowReason" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="rejectionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Why do you want to reject this Portal User?</h5>
            <button (click)="closeReasonModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
        <c-input-group class="mb-3 has-validation" >
            <span cInputGroupText>
                Reason
            </span>
            <input [valid]="bValidReason" cFormControl formControlName="reasonControl" id="RejectReason" type="text"/>
            <c-form-feedback [valid]="ifReasonValid() === ''?true:false">{{ifReasonValid()}}</c-form-feedback>
        </c-input-group>
        </c-modal-body>
        <c-modal-footer>
            <button cButton color="secondary" (click)="closeReasonModal()">
            Don't want to reject
            </button>
            <button cButton color="primary" (click)="RejectCustomer()">Confirmed - please reject</button>
        </c-modal-footer>
    </form>
</c-modal>

<c-modal [visible]="bShowActivationReason" alignment="center" [backdrop]="'static'">
    <form cForm class="row g-2" [formGroup]="activationRejectionForm" class="needs-validation" novalidate>
        <c-modal-header>
            <h5 cModalTitle>Please Confirm</h5>
            <button (click)="closeActivationReasonModal()" cButtonClose></button>
        </c-modal-header>
        <c-modal-body>
          Do you want to Approve or Reject the Portal User creation request for <b>{{selectedUserName}}</b>?
        </c-modal-body>
        <c-modal-footer>
            <div class="row">
              <div class="col">
                <button cButton color="primary" (click)="approveActivationRequest(true)">
                  Approve
                </button>
              </div>
              <div class="col">
                <button cButton color="danger" (click)="approveActivationRequest(false)">
                  Reject
                </button>
              </div>
              <div class="col">
                <button cButton color="secondary" (click)="closeActivationReasonModal()">
                  Cancel
                </button>
              </div>
            </div>
        </c-modal-footer>
    </form>
</c-modal>
<c-modal [visible]="bShowApproveReason" alignment="center" [backdrop]="'static'">
 
      <c-modal-header>
          <h5 cModalTitle>Confirm</h5>
          <button (click)="closeApproveReasonModal()" cButtonClose></button>
      </c-modal-header>
      <c-modal-body>
       <b>Approved successfully!</b>
      </c-modal-body>
      <c-modal-footer>
          <div class="row">
            
            <div class="col">
              <button cButton color="secondary" (click)="closeApproveReasonModal()">
                Cancel
              </button>
            </div>
          </div>
      </c-modal-footer>
  
</c-modal>
<c-smart-table
    [columnSorter]="true"
    [columns]="columns"
    [columnFilter]="true"
    [itemsPerPageSelect]="true"
    [itemsPerPage]="15"
    [items]="usersData"
    [tableBodyProps]="{ align: 'middle' }"
    [tableProps]="{ hover: true, striped: true, responsive: true }"
    (rowClick)="rowSelected($event)"
    clickableRows
    header
    pagination>
    <ng-template cTemplateId="tableData" let-columnName="columnName" let-item="item" let-tdContent="tdContent">
      <td>
        <ng-container [ngSwitch]="columnName">
          <ng-container *ngSwitchDefault>
            {{tdContent}}
          </ng-container>
        </ng-container>
      </td>
    </ng-template>
</c-smart-table>
